<template>
  <b-modal
    id="upgrade-team-level-modal"
    title="Upgrade Team Level"
    cancel-variant="outline-secondary"
    ok-title="Confirm"
    cancel-title="Cancel"
    :ok-disabled="upgrading"
    :cancel-disabled="upgrading"
    :busy="upgrading"
    centered
    @ok="upgradeTeamLevel"
  >
    <p class="mb-0">
      Are you sure you want to upgrade this team to the next level?
    </p>
  </b-modal>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BModal } from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BModal,
  },
  props: {
    teamId: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit, root }) {
    const upgrading = ref(false)

    const upgradeTeamLevel = async bvModalEvt => {
      bvModalEvt.preventDefault()
      upgrading.value = true

      try {
        await axiosIns.patch(`/teams/ranks/${props.teamId}/upgrade`)
        
        root.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            text: 'Team level upgraded successfully',
            variant: 'success',
            icon: 'CheckIcon',
          },
        })

        emit('level-upgraded')
        root.$bvModal.hide('upgrade-team-level-modal')
      } catch (error) {
        root.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            text: error.response?.data?.message || 'Failed to upgrade team level',
            variant: 'danger',
            icon: 'AlertTriangleIcon',
          },
        })
      } finally {
        upgrading.value = false
      }
    }

    return {
      upgrading,
      upgradeTeamLevel,
    }
  },
}
</script>

